/**
 * Determines the MUI Chip color based on order or payment status.
 * Handles various common statuses found in the application.
 *
 * @param {string|null|undefined} status - The status string (e.g., 'pending', 'delivered', 'paid').
 * @returns {string} The corresponding MUI Chip color prop value ('default', 'warning', 'info', 'primary', 'success', 'error', 'secondary').
 */
export const getStatusChipColor = (status) => {
  switch (status?.toLowerCase()) {
    // Order Statuses (including some payment/return overlap)
    case "pending":
    case "awaiting_payment":
    case "requires_payment_method":
    case "requires_confirmation":
    case "requires_action":
    case "partially_refunded": // Often requires attention
      return "warning";

    case "processing":
    case "paid": // Treat 'paid' payment status like processing
    case "return_processing":
      return "info";

    case "shipped":
      return "primary";

    case "delivered":
    case "succeeded": // Successful PaymentIntent status
    case "returned":
      return "success";

    case "canceled":
    case "return_rejected":
    case "failed": // Generic failure or PaymentIntent failure
      return "error";

    case "return_requested":
    case "return_approved":
      return "secondary"; // Use secondary or another distinct color for returns

    case "refunded":
      return "default"; // Or maybe 'success' depending on context?

    default:
      return "default";
  }
};
